var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "overlay-dialog" }, [
    _c("h2", {
      staticClass: "overlay-dialog__title",
      domProps: { innerHTML: _vm._s(_vm.$t("cart.locationEdit.title")) }
    }),
    _vm._v(" "),
    _c("div", { staticClass: "overlay-dialog__text" }, [
      _c("p", {
        domProps: { innerHTML: _vm._s(_vm.$t("cart.locationEdit.text")) }
      })
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "overlay-dialog__buttons" },
      [
        _c("Button", {
          attrs: {
            level: "tertiary",
            type: "button",
            text: _vm.$t("cart.locationEdit.cancelButton"),
            arrow: "",
            reverse: ""
          },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.$emit("cancel")
            }
          }
        }),
        _vm._v(" "),
        _c("Button", {
          attrs: {
            level: "primary",
            type: "button",
            text: _vm.$t("cart.locationEdit.acceptButton")
          },
          on: {
            click: function($event) {
              $event.preventDefault()
              return _vm.$emit("confirm")
            }
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }